import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type NotificationMessageJSON = z.infer<typeof NotificationMessageSchema.NotificationMessageJSONZ>;
export type NotificationMessageParams = z.infer<typeof NotificationMessageSchema.NotificationMessageZ>;

export default class NotificationMessageSchema {
  public static readonly NotificationMessageJSONZ = z.string().min(1);
  public static readonly NotificationMessageZ = z.string().min(1);

  public static validateParams(values: unknown): NotificationMessageParams {
    return parseOrThrow(NotificationMessageSchema.NotificationMessageZ, values, {
      logError: true,
      schemaName: "NotificationMessageSchema",
      operation: "validateParams",
      payloadSample: values,
    });
  }

  public static validateJSON(values: unknown): NotificationMessageParams {
    return parseOrThrow(NotificationMessageSchema.NotificationMessageJSONZ, values, {
      logError: true,
      schemaName: "NotificationMessageSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is NotificationMessageParams {
    try {
      NotificationMessageSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): NotificationMessageParams {
    const parsed = parseOrThrow(NotificationMessageSchema.NotificationMessageJSONZ, data, {
      logError: true,
      schemaName: "NotificationMessageSchema",
      operation: "deserialize",
      payloadSample: data,
    });
    return NotificationMessageSchema.codec.decode(parsed);
  }

  public static serialize(data: NotificationMessageParams): NotificationMessageJSON {
    const parsed = NotificationMessageSchema.validateJSON(data);
    return NotificationMessageSchema.codec.encode(parsed);
  }

  public static readonly codec = z.codec(
    NotificationMessageSchema.NotificationMessageJSONZ,
    NotificationMessageSchema.NotificationMessageZ,
    {
      decode: (json) => json,
      encode: (params) => params,
    }
  );
}
